<template>
  <footer class="tw-bg-very-dark-gray tw-p-8 tw-text-white">
    <div class="tw-mx-auto tw-max-w-7xl">
      <div
        class="tw-flex tw-flex-col tw-items-center tw-justify-between tw-gap-6 md:tw-flex-row"
      >
        <!-- Left side - Links -->
        <div class="tw-flex tw-items-center tw-gap-6">
          <router-link
            to="/privacy-policy"
            class="tw-text-white/80 tw-transition-colors tw-duration-200 hover:tw-text-white"
          >
            Privacy Policy
          </router-link>
          <router-link
            to="/terms-and-conditions"
            class="tw-text-white/80 tw-transition-colors tw-duration-200 hover:tw-text-white"
          >
            Terms & Conditions
          </router-link>
        </div>

        <!-- Right side - Copyright -->
        <div class="tw-text-sm tw-text-white/60">
          &copy; {{ new Date().getFullYear() }} Octocal. All rights reserved.
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
div:has(a) {
  @apply tw-leading-none;
}
a {
  @apply tw-text-white/80 !important;
}
a:hover {
  @apply tw-text-white !important;
}
</style>

<script>
import { mapActions } from "vuex"

export default {
  name: "Footer",
  data() {
    return {
      contractAddress: "2uHvhSasjzHm4PPAWaVpuU7yKtd4yUGYx6WK2oxutQnm",
    }
  },
  computed: {
    contractAddressTruncated() {
      return (
        this.contractAddress.slice(0, 6) +
        "..." +
        this.contractAddress.slice(-4)
      )
    },
  },
  methods: {
    ...mapActions(["showInfo"]),
    copyContractAddress() {
      navigator.clipboard
        .writeText(this.contractAddress)
        .then(() => {
          this.showInfo("Contract address copied to clipboard!")
        })
        .catch((err) => {
          console.error("Failed to copy contract address: ", err)
          // Optionally, show an error message to the user
        })
    },
  },
}
</script>
